import React from 'react';
import styles from './Contact.module.css';

const SubmissionConfirmation = ({ status, quoteAmount, deckChoice }) => {
  let message;
  let className = `${styles.step} ${styles.submissionMessage}`;

  switch (status) {
    case 'submitting':
      message = "Submitting your request...";
      break;
    case 'success':
      message = "Thank you for submitting your request. We will get back to you shortly.";
      className += ` ${styles.success}`;
      break;
    case 'error':
      message = "There was an error submitting your form. Please try again.";
      className += ` ${styles.error}`;
      break;
    default:
      message = "Something went wrong. Please try again.";
      className += ` ${styles.error}`;
  }

  return (
    <div className={styles.step}>
      <h2>Quote Request {status === 'success' ? 'Submitted' : 'Status'}</h2>
      <p className={className}>{message}</p>
      {status === 'success' && (
        <div className={styles.quoteResult}>
          <h3>Estimated Quote</h3>
          <p>
            {deckChoice === 'custom' ? (
              <span>Your quote will be determined based on your custom drawing.</span>
            ) : (
              <span>Based on the information you provided, your estimated quote is:</span>
            )}
          </p>
          {deckChoice !== 'custom' && (
            <p className={styles.quoteAmount}>${quoteAmount ? quoteAmount.toFixed(2) : '0.00'}</p>
          )}
          <p className={styles.quoteDisclaimer}>
            Please note that this is an initial estimate and may be subject to change upon detailed review of your project.
          </p>
        </div>
      )}
    </div>
  );
};

export default SubmissionConfirmation;